import { Image, Typography } from 'antd'
import styled from 'styled-components'

const { Title, Text } = Typography

export const EmptyState = () => {
  return (
    <SStyledWrapper>
      <Image
        src="/images/trash.svg"
        alt="Trash"
        width={192}
        preview={false}
      />

      <Title level={5}
        className="title"
      >
There are no items in the trash bin
      </Title>

      <Text className="subtitle">
        Move unnecessary assets and boards to the trash bin. They will be forever deleted after 30 days.
      </Text>
    </SStyledWrapper>
  )
}


const SStyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: calc(100vh - 300px);
  padding: 24px;

  .ant-empty {
    margin-bottom: 0;
  }

  .title {
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .subtitle {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    max-width: 500px;
  }
`

